import { Base } from '@studiometa/js-toolkit';

/**
 * AnchorNav component
 * Fixed navigation at the bottom of the screen for sections with anchors
 */
export default class AnchorNav extends Base {
  static config = {
    name: 'AnchorNav',
    refs: ['list', 'items[]'],
  };

  /** @type {Array<{id: string, title: string, element: HTMLElement}>} */
  sections = [];

  /** @type {number} */
  currentIndex = -1;

  /** @type {boolean} */
  needsUpdate = false;

  /**
   *
   */
  mounted() {
    this.collectSections();

    if (this.sections.length === 0) {
      this.$el.remove();
      return;
    }

    this.$el.classList.remove('hidden');
    this.updateActiveItem();
  }

  /**
   * Collections sections from the DOM with data-anchor="true" attribute
   * and add them to the sections array
   * @returns {void}
   */
  collectSections() {
    document.querySelectorAll('[data-anchor="true"]').forEach((section) => {
      if (!(section instanceof HTMLElement)) {
        return;
      }

      const id = section.id;
      const title = section.dataset.anchorTitle;

      if (id && title) {
        this.sections.push({ id, title, element: section });
      }
    });
  }

  /**
   * Called on scroll events
   */
  scrolled() {
    // Mark that we need to update on next tick
    this.needsUpdate = true;
  }

  /**
   * Called on each animation frame
   */
  ticked() {
    // Only update if scroll happened
    if (this.needsUpdate) {
      this.updateActiveItem();
      this.needsUpdate = false;
    }
  }

  /**
   *
   */
  updateActiveItem() {
    const threshold = window.innerHeight / 3;
    let newIndex = -1;

    // Find the last section whose top is above the threshold
    for (let i = this.sections.length - 1; i >= 0; i--) {
      const rect = this.sections[i].element.getBoundingClientRect();
      if (rect.top <= threshold) {
        newIndex = i;
        break;
      }
    }

    // If no section found and we have sections, default to first if we're at top
    if (newIndex === -1 && this.sections.length > 0) {
      const firstRect = this.sections[0].element.getBoundingClientRect();
      if (firstRect.top <= window.innerHeight) {
        newIndex = 0;
      }
    }

    if (newIndex !== this.currentIndex) {
      this.currentIndex = newIndex;

      this.$refs.items.forEach((item, index) => {
        const isActive = index === newIndex;
        item.classList.toggle('text-brown-900', isActive);
        item.classList.toggle('font-semibold', isActive);
        item.classList.toggle('border-brown-900', isActive);
        item.classList.toggle('text-brown-900/60', !isActive);
        item.classList.toggle('border-transparent', !isActive);
      });
    }
  }
}
